const STATUS_STYLES = {
  active: "bg-emerald-50 text-emerald-700 border-emerald-200",
  cancelled: "bg-red-50 text-red-700 border-red-200",
  churned: "bg-red-50 text-red-700 border-red-200",       // legacy alias
  completed: "bg-sky-50 text-sky-700 border-sky-200",
  free_pause: "bg-amber-50 text-amber-700 border-amber-200",
  paid_pause: "bg-violet-50 text-violet-700 border-violet-200",
  paused: "bg-amber-50 text-amber-700 border-amber-200",  // legacy alias
  buyer: "bg-slate-100 text-slate-700 border-slate-200",
  paid: "bg-emerald-50 text-emerald-700 border-emerald-200",
  pending: "bg-amber-50 text-amber-700 border-amber-200",
  scheduled: "bg-blue-50 text-blue-700 border-blue-200",
  recurring: "bg-brand-blue-soft text-brand-blue-dark border-blue-200",
  oneoff: "bg-brand-orange-soft text-orange-700 border-orange-200",
  neutral: "bg-gray-50 text-gray-700 border-gray-200",
};

const STATUS_LABELS = {
  free_pause: "Free pause",
  paid_pause: "Paid pause",
  completed: "Completed",
};

export default function Pill({ status = "neutral", children, className = "" }) {
  const style = STATUS_STYLES[status] || STATUS_STYLES.neutral;
  const label = children ?? STATUS_LABELS[status] ?? status;
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${style} ${className}`}>
      {label}
    </span>
  );
}